//#region src/utils/draw-relationship/bezier.ts
var VIEW_CURVATURE = .25;
var CURVATURE_SCALE = 25;
function curveReach(gap) {
	return VIEW_CURVATURE * CURVATURE_SCALE * Math.sqrt(Math.max(gap, 0));
}
function controlOffset(distance) {
	return distance >= 0 ? distance / 2 : curveReach(-distance);
}
function control(from, outward, to) {
	const offset = controlOffset((to.x - from.x) * outward.x + (to.y - from.y) * outward.y);
	return {
		x: from.x + outward.x * offset,
		y: from.y + outward.y * offset
	};
}
function bezierControls(from, fromOutward, to, toOutward) {
	return [control(from, fromOutward, to), control(to, toOutward, from)];
}
function bezierPolyline(from, fromOutward, to, toOutward, segments = 24) {
	const [first, second] = bezierControls(from, fromOutward, to, toOutward);
	return cubicPolyline(from, first, second, to, segments);
}
function cubicPolyline(from, first, second, to, segments) {
	const count = Math.max(1, Math.floor(segments));
	const points = [{
		x: from.x,
		y: from.y
	}];
	for (let step = 1; step <= count; step++) {
		const at = step / count;
		points.push({
			x: cubic(from.x, first.x, second.x, to.x, at),
			y: cubic(from.y, first.y, second.y, to.y, at)
		});
	}
	return points;
}
function cubic(p0, p1, p2, p3, at) {
	const rest = 1 - at;
	return rest * rest * rest * p0 + 3 * rest * rest * at * p1 + 3 * rest * at * at * p2 + at * at * at * p3;
}
//#endregion
export { VIEW_CURVATURE, bezierControls, bezierPolyline, cubicPolyline, curveReach };
